import axiosInstance from "./api";

const chatApi = {
  // Get or initialize canonical chat room for a proposal
  getOrCreateProposalRoom: (proposalId) =>
    axiosInstance.get(`/chat/proposal/${proposalId}/room`),

  // Fetch paginated messages for a room
  getRoomMessages: (roomId, params = {}) =>
    axiosInstance.get(`/chat/rooms/${roomId}/messages`, { params }),

  // Get total unread count across all rooms for current user
  getUnreadSummary: () =>
    axiosInstance.get("/chat/unread-summary"),

  // Admin audit: list all rooms
  getAdminRooms: (params = {}) =>
    axiosInstance.get("/chat/admin/rooms", { params }),

  // Admin audit: fetch messages for any room
  getAdminRoomMessages: (roomId, params = {}) =>
    axiosInstance.get(`/chat/admin/rooms/${roomId}/messages`, { params }),
};

export default chatApi;

